module.exports = __webpack_public_path__ + "static/media/chart.e73a8e6e.jpg";